const getKenmerkElementId = (kenmerkId: number): string =>
  `realworks-kenmerk-${kenmerkId}`;

export default getKenmerkElementId;
